const initialState = {
  data: {
    list: [],
    total: 0,
  },
  isLoading: false,
  error: "",
};

export const getRightToRentListSuccess = (state, {payload}) => ({
  ...state,
  data: payload,
  isLoading: false,
});

export const clearState = () => ({...initialState});

export default initialState;
